import React, { useState } from 'react';
import { IconLock } from '../../components/Icons';
import UserIdForm from '../../components/UserIdForm';

/**
 * **초기화된 아이디로 들어오면 맨 처음 뜨는 아이디 변경 창** (사용자 2026-10-27 "초기화된 아이디로 들어가면 맨 처음 아이디 변경 팝업 뜨게해").
 * 운영자가 길드원 관리 창에서 [아이디 초기화]를 하면 서버가 idResetPending 을 켜고, /api/auth/me 가 mustChangeId 로 알린다.
 * 초기화된 아이디는 운영자가 아는 아이디라 본인이 새로 정할 때까지 닫지 않는다 — 바꾸면 잠깐 결과를 보여 주고 [확인]으로 닫는다.
 * 프로필 창과 같은 밝은 판·보라 강조(다크모드는 utils/theme 가 알아서 어둡게).
 */
export default function IdResetModal({ onDone, onLogout }: {
  /** 새 아이디로 바꿨다 — 화면의 user 를 고친다(mustChangeId 끔) */
  onDone: (id: string) => void;
  onLogout: () => void;
}) {
  const [done, setDone] = useState<string | null>(null);
  return (
    <div style={{
      position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', zIndex: 400,
      background: 'rgba(15, 20, 35, 0.45)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        background: '#ffffff', borderRadius: 20, width: 'min(92vw, 360px)', boxSizing: 'border-box', padding: '22px 18px 16px',
        boxShadow: '0 18px 50px rgba(30, 40, 80, 0.25)', border: '1px solid #e8ecf3', display: 'flex', flexDirection: 'column', gap: 10
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{
            width: 38, height: 38, borderRadius: 11, flexShrink: 0, background: 'rgba(102, 126, 234, 0.12)', color: '#667eea',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19
          }}><IconLock /></span>
          <div style={{ fontSize: 17, fontWeight: 800, color: '#222' }}>새 아이디를 정해 주세요</div>
        </div>
        <div style={{ fontSize: 13, color: '#667085', fontWeight: 600, lineHeight: 1.5 }}>
          운영자가 아이디를 초기화했습니다. 앞으로 로그인할 아이디를 직접 정해 주세요.
        </div>
        {done ? (
          <>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#16a34a', lineHeight: 1.5 }}>
              아이디를 '{done}' 로 바꿨습니다. 다음 로그인부터 이 아이디로 들어오세요.
            </div>
            <button
              type="button"
              onClick={() => onDone(done)}
              style={{
                padding: '11px 0', borderRadius: 12, border: 'none', fontWeight: 800, fontSize: 15, cursor: 'pointer',
                background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff'
              }}
            >확인</button>
          </>
        ) : (
          <>
            <UserIdForm onChanged={setDone} />
            <button
              type="button"
              onClick={onLogout}
              style={{ alignSelf: 'center', marginTop: 4, padding: '4px 8px', border: 'none', background: 'transparent', color: '#98a2b3', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}
            >로그아웃</button>
          </>
        )}
      </div>
    </div>
  );
}
